import {
  ImageProps,
  Slide,
  chartOptionsToBase64Svg,
} from '@features/powerpoint';
import { contentSlideHeader } from '../../../../../utils';
import { CampaignAnalyticsSlideProps } from '../build-campaign-analytics-slides';
import { CHART_HEIGHT, CHART_WIDTH } from './charts';
import { buildChartOptions } from '@configurations/campaignAnalytics/footTrafficOverlapChart';
import { Options } from 'highcharts';

export const footTrafficOverlapChartSlide = (
  props: CampaignAnalyticsSlideProps
): Slide => {
  const chartOptions: Options = buildChartOptions(
    props.campaignAnalyticsReport.footTrafficOverlap.data
  );

  const footTrafficOverlapChartSvg: string = chartOptionsToBase64Svg({
    chartOptions,
    height: CHART_HEIGHT,
    width: CHART_WIDTH,
  });

  const images: ImageProps[] = [
    {
      data: footTrafficOverlapChartSvg,
      w: 11.85,
      h: 5.22,
      x: 0.74,
      y: 1.66,
    },
  ];

  return {
    slideMaster: props.slideMaster,
    texts: [contentSlideHeader('Foot Traffic Overlap')],
    images,
  };
};
